export const minusIcon = {
  data: ` <svg viewBox="0 0 32 32">
            <title>minus</title>
            <path
              stroke-linejoin="miter"
              stroke-linecap="round"
              stroke-miterlimit="4"
              d="M3 15h26"
            ></path>
          </svg>`,
  name: 'minus',
};
